import React from "react";
import "./CharlotteAbout.scss";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import cgb from "../../Media/Charlotte.webp";
const rumah = () => {
  return (
    <div id="charlotte" className="rumahjasmia">
      <h1>Welcome to Cluster Charlotte</h1>
      <h2>Cicilan Start From 3 Juta/Bulan</h2>
      <div className="herojasmia">
        <img className="fotohome" src={cgb} alt={cgb} />
        <div className="desk-jasmia">
          Cluster Charlotte adalah salah satu klaster perumahan di CitraLand
          City Kedamean, Gresik, yang menawarkan berbagai tipe rumah dengan
          desain modern dan harga terjangkau. Klaster ini dirancang khusus untuk
          memenuhi kebutuhan keluarga muda dengan fasilitas dan lingkungan yang
          nyaman. Cluster Charlotte mengusung tema "Eco Living Residence", yang
          menekankan pada lingkungan hijau.
        </div>
      </div>
    </div>
  );
};

export default rumah;
